import styled from '@emotion/styled';
import { Typography, Grid } from '@mui/material';
import { colorPalette } from 'styles/partials/colors';

export const HiddenButton = styled.button({
  background: 'white',
  width: '100%',
  cursor: 'pointer',
  border: 'none',
  padding: 0,
});

export const GridContainer = styled(Grid)({
  marginTop: '24px',
});

export const GridSubcontainer = styled(Grid)({
  marginTop: '20px',
});

export const SubtitleSize = styled(Typography)({
  color: colorPalette.darkGray1,
  fontWeight: 500,
  fontSize: '14px',
  marginLeft: '8px',
  textAlign: 'right',
});
